import { TechnicalSupportDto } from '../interfaces/dtos/ContactUsDto';
import { TechnicalSupport } from '../interfaces/TechnicalSupport';
import transformContact from './transformContact';

export default function transformTechnicalSupport(dto: TechnicalSupportDto): TechnicalSupport {
  return {
    contact: transformContact(dto.contact),
    informations: dto.informations,
  };
}
